// src/components/MaintenanceScreen.tsx
import Header from "./Header";

export default function MaintenanceScreen({ message }: { message: string }) {
  return (
    <div className="min-h-screen bg-[#EAF3FF] flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="max-w-md w-full rounded-2xl bg-white shadow-lg px-6 py-8 text-center">
          <div className="mb-1 text-xs font-semibold text-amber-600">
            중요 안내
          </div>
          <h1 className="mb-3 text-lg font-bold text-slate-900">
            현재 화면 작업 중입니다.
          </h1>
          <p className="text-sm text-slate-600 whitespace-pre-line">
            {message}
          </p>
        </div>
      </main>
    </div>
  );
}
